import React from "react";
import { motion } from "framer-motion";

export const Waveform = ({ bars = 28, color = "#d4af37", className = "" }) => (
  <div
    data-testid="ambient-waveform"
    className={`flex items-end gap-[3px] h-6 ${className}`}
    aria-hidden
  >
    {Array.from({ length: bars }).map((_, i) => (
      <motion.span
        key={i}
        className="wave-bar inline-block w-[2px] rounded-full"
        style={{
          background: color,
          animationDelay: `${(i % 8) * 0.12}s`,
          height: `${20 + (i % 5) * 18}%`,
        }}
      />
    ))}
  </div>
);
